import { z } from 'zod';
import { useDialogFormControls, CommanderFormProps } from '@mews-commander/form';
import { useInvalidateRepositoryQuery, useRepositoryMutation } from '@mews-commander/data-access';
import { InvoiceAsyncSelectSimple } from '../../InvoiceAsyncSelect/InvoiceAsyncSelectSimple';

interface PaymentLinkInvoiceFormProps extends CommanderFormProps {
    paymentId: string;
    accountId: string;
}

// TODO: use schema in resolver
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const InvoicePaymentLinkFormSchema = z.object({
    invoiceIds: z.string().array(),
});

type PaymentLinkInvoiceFormValues = z.infer<typeof InvoicePaymentLinkFormSchema>;

export const PaymentLinkInvoiceForm = ({
    paymentId,
    accountId,
    onSubmitting,
    onSubmitted,
    onSuccess,
    formRef,
}: PaymentLinkInvoiceFormProps) => {
    const invalidateQuery = useInvalidateRepositoryQuery();
    const { mutate } = useRepositoryMutation('payments', 'linkToInvoices', {
        onSuccess: () => {
            void invalidateQuery('payments', 'getAll', { accountId });
        },
    });

    const { renderFormContent } = useDialogFormControls<PaymentLinkInvoiceFormValues>({
        formRef,
        onSubmit: ({ invoiceIds }) => {
            onSubmitting?.();
            mutate(
                { invoiceIds, paymentId },
                {
                    onSettled: onSubmitted,
                    onSuccess,
                }
            );
        },
    });

    return renderFormContent(<InvoiceAsyncSelectSimple name="invoiceIds" required accountId={accountId} />);
};
